import {
  reactQueryDelete,
  reactQueryPatch,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";

import { internalApi } from "../helpers/urlHelpers";

interface ChatRoomParticipantApiProps {
  admin?: boolean;
  archived?: boolean;
  chat_room_participant?: any;
  id?: number;
  muted?: boolean;
  uuid: string;
}

const create = (params: ChatRoomParticipantApiProps) => {
  const { uuid, chat_room_participant } = params || {};
  return reactQueryPost(internalApi.chatRoomParticipants.create({ uuid }), {
    chat_room_participant,
  });
};

const update = (params: ChatRoomParticipantApiProps) => {
  const {
    uuid,
    id,
    admin: isAdmin,
    archived: isArchived,
    muted: isMuted,
  } = params || {};
  return reactQueryPatch(
    internalApi.chatRoomParticipants.update({ uuid, id }),
    {
      admin: isAdmin,
      archived: isArchived,
      muted: isMuted,
    },
  );
};

const destroy = (params: ChatRoomParticipantApiProps) => {
  const { uuid, id } = params || {};
  return reactQueryDelete(
    internalApi.chatRoomParticipants.destroy({ uuid, id }),
  );
};

export const chatRoomParticipantApi = {
  create,
  update,
  destroy,
};
